module.exports = __webpack_public_path__ + "img/1.6f65b213.jpg";